import React, { useState } from 'react';

import { SaveButton ,
  List,
  Datagrid,
  TextField,
  ReferenceField,
  DeleteButton,
  ReferenceInput,
  SelectInput,
  TextInput,
  useTranslate,
  required,    
  useCreate,
  useUpdate,
  useNotify,
  FormWithRedirect,useRefresh,
  Button,
  FunctionField, TopToolbar, NumberInput, ResourceContextProvider,
  ArrayInput,
  SimpleFormIterator, ArrayField
} from 'react-admin';


import EditIcon from '@material-ui/icons/Edit';

import { useStyles  } from '../common/styles';




import Divider from '@mui/material/Divider';

import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';


import { validateMaxLength, validateInteger  } from './../components/Validator';

export const UsersSectionsList = (props) => {
  const translate = useTranslate(); 
    
  let strRedirect =  `/users/${props.users_id}/more_federation`; 
    
  return (
           
    <ResourceContextProvider value="users_sections" >
      <List 
        syncWithLocation 
        basePath="/users_sections" 
        filter={{ users_id : props.users_id }}  
        title=""
        bulkActionButtons={false}                
        actions={<CustomToolbar users_id={props.users_id} /> }  
        perPage={1000}
        sort={{ field: 'year', order: 'ASC' }} 
        empty={<CustomToolbar users_id={props.users_id} /> } 
        pagination={false}
      >

        <Datagrid   
          expand={<UsersSectionsDetails />} 
          className="header_grey6"
          label=""
          fullWidth
        >
          <TextField source="year" label={translate('common.year')} sortable={false} /> 
          <FunctionField label={translate('users_sections.num_sections')} render={record => <RenderNumSections record={record} /> } sortable={false} />
          <FunctionField label={translate('users_sections.total_participants')} render={record => <RenderTotalParticipants record={record} /> } sortable={false} />
          <CustomEditButton label=""/>
          <DeleteButton undoable={false} redirect={strRedirect} label=""/>
        </Datagrid>

      </List> 
    </ResourceContextProvider>

  );
};

export const CustomEditButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [update, { loading, error }] = useUpdate();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };
                        
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'users_sections', 
        payload : { id: values.id, data : 
                {       users_id: values.users_id,
                  year : values.year, 
                  items: values.items
                } }
      },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    

  return (
    <>
      <Button onClick={handleClick} label="" startIcon={<EditIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
      >
        <DialogTitle>{translate('users_sections.edit')}</DialogTitle>

        <FormWithRedirect
          resource=""
          save={handleSubmit}
          initialValues={{ id : props.record.id, 
            users_id: props.record.users_id,
            year : props.record.year, 
            items: props.record.items
          }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <CustomForm edit={true} />
                            
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const RenderNumSections = ({ record, ...props }) => {
    
  let num_sections = 0;
  if (record.items)
  {
    record.items.forEach(element => { num_sections++; } );
  }
    
  return ( num_sections );
};

const RenderTotalParticipants = ({ record, ...props }) => {
    
  let total_participants = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.participants) total_participants+=element.participants; } );
  }
    
  return ( total_participants );
    
};

export const UsersSectionsShow = ({ ...props }) => {
  const translate = useTranslate();   

  return (
        
    <ResourceContextProvider value="users_sections" >
      <List 
        syncWithLocation 
        basePath="/users_sections" 
        filter={{ users_id : props.users_id }}  
        title=""
        bulkActionButtons={false}                                
        perPage={1000}
        sort={{ field: 'year', order: 'ASC' }} 
        pagination={false}
        actions={false}
        empty={<></>}
        className="users_remittances_list"
      >                            
        <Datagrid
          expand={<UsersSectionsDetails />} 
          className="header_grey6"
          fullWidth
        >   
          <TextField source="year" label={translate('common.year')} sortable={false}  />   
          <FunctionField label={translate('users_sections.num_sections')} render={record => <RenderNumSections record={record} /> } sortable={false} />
          <FunctionField label={translate('users_sections.total_participants')} render={record => <RenderTotalParticipants record={record} /> } sortable={false} />
        </Datagrid>

      </List> 

    </ResourceContextProvider>            

  );
};

export const CustomToolbar = ({ ...props }) => {

  return (
        
    <TopToolbar>
      <CustomCreateButton users_id={props.users_id} />
    </TopToolbar>
        
  );
};


export const CustomCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('users_sections');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
    

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };


  return (
    <>            
      <Button onClick={handleClick} label={translate('users_sections.create_button')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('users_sections.create')}
      >
        <DialogTitle>{translate('users_sections.create')}</DialogTitle>

        <FormWithRedirect
          resource="users_sections"
          save={handleSubmit}
          initialValues={{ users_id : props.users_id }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <CustomForm edit={false} />
                            
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const CustomForm = ({ edit, ...props }) => {
  const translate = useTranslate(); 
  const classes = useStyles();
    
  return (
    <DialogContent className="users_sections_form">
      <br />
      <Grid container spacing={2} >
        <Grid item xs={3}>  
          { edit ? (
            <NumberInput label={translate('common.year')} fullWidth source="year" step={1} disabled />                                        
          ) : (
            <NumberInput label={translate('common.year')} fullWidth source="year" step={1} validate={[required(),validateInteger(translate('common.validation.number'))]} />                           
          )}
        </Grid> 
      </Grid>
                
      <ArrayInput source="items" label="">
        <SimpleFormIterator 
          disableReordering                     
        >
          <ReferenceInput sort={{ field: 'priority', order: 'ASC' }}  perPage={1000} label={translate('users_sections.name')} source="sections_users_id" reference="sections_users" className="mt-10">
            <SelectInput fullWidth optionText="name" optionValue="id" validate={required()} />
          </ReferenceInput> 
          <NumberInput source="participants" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_sections.participants')} />
          <TextInput fullWidth source="comment" validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} label={translate('common.comment')} />
        </SimpleFormIterator>
      </ArrayInput>
                        
    </DialogContent>
  );
    
    
};
    

export const UsersSectionsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
    
  let num_sections = 0;
  if (record.items)
  {
    record.items.forEach(element => { num_sections++; } );
  }
    
  let total_participants = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.participants) total_participants+=element.participants; } );
  }
    
  return (
    <div className="usersEconomicDataExpand">
      <Grid container spacing={2}>
        <Grid item xs={2} >
          <FunctionField render={record => <TextFieldShow source={record.year} label={translate('common.year')} /> } />
        </Grid>
        <Grid item xs={3} >
          <FunctionField render={record => <TextFieldShow source={num_sections} label={translate('users_sections.num_sections')} /> } />
        </Grid>
        <Grid item xs={3} >
          <FunctionField render={record => <TextFieldShow source={total_participants} label={translate('users_sections.total_participants')} /> } />
        </Grid>
      </Grid>
        
      <br />
      <Divider className="" />
      <br />
      <ArrayField source="items">
        <Datagrid>
          <ReferenceField label={translate('users_sections.name')} source="sections_users_id" reference="sections_users" link={false} > 
            <TextField source="name" />                               
          </ReferenceField>
          <TextField source="participants" label={translate('users_sections.participants')} />
          <TextField source="comment" label={translate('common.comment')} />
        </Datagrid>
      </ArrayField>
        
      <br /> 
    </div>
  );
};